import { createSlice } from '@reduxjs/toolkit';
import { SahabatScarlettResponse } from '../../types/sahabatScarlett';

interface SahabatScarlettState {
  data: Partial<SahabatScarlettResponse>;
  submitSuccess?: boolean;
}

const initialState: SahabatScarlettState = {
  data: {},
  submitSuccess: false,
};

export const slice = createSlice({
  name: 'sahabatScarlettSlice',
  initialState,
  reducers: {
    setSahabatScarlettList(state, action) {
      state.data = action.payload;
    },
    setSubmitSuccess(state, action) {
      state.submitSuccess = action.payload.submitSuccess;
    },
  },
});

export const { setSahabatScarlettList, setSubmitSuccess } = slice.actions;
export default slice.reducer;
